export const months = {
  january: 'Jan',
  february: 'Feb',
  march: 'Mar',
  april: 'Apr',
  may: 'May',
  june: 'Jun',
  july: 'Jul',
  august: 'Aug',
  september: 'Sep',
  october: 'Oct',
  november: 'Nov',
  december: 'Dec',
};
export const serviceOptionsList = [
  { value: 'All', label: 'All' },
  { value: 'Assurance', label: 'Assurance (excl. ACR)' },
  { value: 'Consulting', label: 'Consulting' },
  { value: 'SAT', label: 'SAT (excl. ITTS)' },
  { value: 'TAX', label: 'TAX (excl. ITTS)' },
  { value: 'ITTS', label: 'ITTS' },
  { value: 'EMIA_ACR', label: 'EMEIA ACR' },
];

export const quarterOptionsList = [
  { value: 'Q1', label: 'Q1', id: 1 },
  { value: 'Q2', label: 'Q2', id: 2 },
  { value: 'Q3', label: 'Q3', id: 3 },
  { value: 'Q4', label: 'Q4', id: 4 },
];

export const abbreviatedMonthList = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const yearlyQuarter = {
  q1: 'Q1',
  q2: 'Q2',
  q3: 'Q3',
  q4: 'Q4',
};

export const monthlyQuarterr = {
  q1: [months.july, months.august, months.september],
  q2: [months.october, months.november, months.december],
  q3: [months.january, months.february, months.march],
  q4: [months.april, months.may, months.june],
};

export const monthlyQuarter = {
  q1: ['july', 'august', 'september'],
  q2: ['october', 'november', 'december'],
  q3: ['january', 'february', 'march'],
  q4: ['april', 'may', 'june'],
};

// SUB_HEADER - Sub Headers Constant
export const SUB_HEADER = {
  DUE_TODAY: 'Due Today',
  DUE_IN: 'Due in',
  DAY: 'Day',
  DAYS: 'Days',
};

// ECM - Exit Confirmation Modal AT PL Screen
export const ECM = {
  HEADER_TITLE: 'Your Changes Are Not Saved',
  DESCRIPTON: 'If you exit the page without submitting, all the changes will be lost.',
  EXIT_BUTTON_TITLE: 'Exit Without Submitting',
};

export const SUBMITSUCCESSFUL = {
  HEADER_TITLE: 'Forecast Submitted',
  DESCRIPTON1: 'Your forecast for',
  DESCRIPTON2: 'was successfully submitted',
  VIEW_DASBOARD: 'View Dashboard',
  AND: 'and',
  FOR: 'for',
  PROJECTION: 'projection for the next two months ',
};

export const FAILEDTRANSACTION = {
  HEADER_TITLE: 'Error',
  MESSAGE_LINE1: 'Unexpected error has occured.',
  MESSAGE_LINE2: 'Please go back and try again.',
};

export const BUTTON_TITLE = {
  CANCEL: 'Cancel',
  SUBMIT: 'Submit',
  VIEW: 'View',
  FORECAST: 'Forecast',
  CLOSE: 'Close',
  OPEN_EY_CRM: 'Open EY CRM',
  RESET: 'Reset',
};

export const warningMessages = {
  do_not_show_again: 'Do not show this message again',
};

export const DATA_CARD_ONE = {
  FORECAST_ACCURACY: 'FORECAST ACCURACY',
  QUARTERLY: 'Quarterly',
  MONTHLY: 'Monthly',
  LABLE: 'Sold vs Submitted | Till Date FY',
};

export const DATA_CARD_TWO = {
  FORECAST_COMPLETION: 'FORECAST COMPLETION',
  SUBMITTED: 'Submitted',
  MISSED: 'Missed',
  REMAINING: 'Remaining',
};

export const DATA_CARD_THREE = {
  TITLE: '% OF OPPS: OPEN TO CLOSE DURATION',
  LABLE_ONE: 'Within 7 days or less',
  LABLE_TWO: 'Within 30 days or less',
  LABLE_THREE: 'Within 90 days or less',
};

export const QUARTERLY_DETAILS = {
  TITLE: 'FORECAST ACCURACY - QUARTER',
  FORECAST_SUMMARY: 'FORECAST SUMMARY',
  COMMIT: 'Commit',
  NO_COMMIT: 'No Commit',
  MONTHLY_DETAILS: 'MONTHLY DETAILS',
  WON: 'Won',
  LOST: 'Lost',
  OPEN: 'Open',
  DECLINED: 'Declined',
  COMMITTED: 'Committed',
  NOT_COMMITTED: 'Not Committed',
  MISSED: 'Missed',
  FORECAST: 'Forecast',
  FORECASTED: 'Forecasted',
  PROJECTED: 'Projected',
  TBD: 'TBD',
  ACCURACY: 'Accuracy',
  GAP: 'Gap',
  COMMIT_OPPS: 'Commit Opps',
  PROJECTED_OPPS: 'Projected Opps',
  WON_OPPS: 'Won Opps',
  NOT_APPLICABLE: 'NA',
};

export const DATA_MISMATCH_ERROR = {
  title: 'Data Mismatch',
  message:
    'There has been a change or update in the data for the selected oppotunties. Please refresh and review the data again.',
  buttonText: 'Close & Refresh',
};

export const SAM = {
  title: 'Submit Acknowledgment',
  message: `By clicking the submit button you acknowledge that you have:`,
  bulletPoint1: 'Verified the judge values are accurate',
  bulletPoint2: 'Confirm the "Your Commit Value" for the next fiscal month',
};

export const PRIVACY_STATEMENT = {
  HEADER_TITLE: 'Privacy Notice',
  DESCRIPTION1: `
    EY does not intentionally collect any sensitive personal data from you via the Tool. The Tool’s intention is not to process such information.`,
  DESCRIPTION2: `
      Accordingly, you should not enter any unnecessary personal information or any sensitive personal data (including government identifiers such as tax file numbers or social security numbers/national identification numbers), client confidential information (except client entity names), audit secrets, state secrets, trade secrets, or anything that would violate professional secrecy or confidentiality rules or that would be considered abusive/irrelevant in the Tool.`,
  DESCRIPTION3: `
      Personal and contact data available in the Tool is intended to be used for supporting communications to deliver services and manage sales and should not be used to contact individuals for marketing purposes.
  `,
};

export const IFRAME_EXIT_MODAL_REFRESH = {
  TITLE: 'Opportunity Details',
  GO_BACK: 'Go Back',
  EXIT_REFRESH: 'Exit & Refresh',
  DESCRIPTION1: 'Did You Save Changes?',
  DESCRIPTION2: "Please make sure you've saved your changes before continuing.",
  DESCRIPTION3: 'You must click "Save" in the header of the Opportunity Details screen.',
  DESCRIPTION4:
    "Ok to Exit Opportunity Details, I've already saved my changes. This will refresh the Sales Forecasting page.",
};

export const FORECAST_SIDEBAR_DATA_CONST = {
  NOW: 'now2',
  NEXT: 'next',
  BEYOND: 'beyond',
};

export const FORECAST_SIDEBAR_QUARTER_CONST = {
  NOW: 'NOW',
  NEXT: 'NEXT',
  BEYOND: 'BEYOND',
};

export const LOGOUT_SCREEN = {
  HEADER_TITLE: 'Logged Out Successfully',
  DESCRIPTION: `
  Your session with the Sales Forecasting Application has ended. To restart the application, please utilize the button below.`,
  BUTTON_TITLE: 'Restart Application',
};

export const ROLE_CONST = {
  PL: 'PL',
  GCSP: 'GCSP',
};

export const TABLE_HEADER_SUBTEXT = {
  DATE_FISCAL_MONTH: 'Date (Fiscal Month)',
  EXCL_ACR: 'excl. ACR',
  EXCL_ITTS: 'excl. ITTS',
  ACTUAL_FORECASTED: 'Actual vs (Forecasted)',
};

export const PAGE = {
  DESKTOP: 'desktop',
  FORECAST: 'forecast',
  PAST_FORECAST: 'past forecast',
};

export const OPERATING_SYSTEM = {
  WINDOWS: 'WINDOWS',
  MAC: 'MAC',
  LINUX: 'LINUX',
  ANDROID: 'ANDROID',
  IOS: 'IOS',
};

//tags
export const MONTH_QUARTER_STATUS = {
  NOT_APPLICABLE: 'not applicable',
  MISSED: 'missed',
  SUBMITTED: 'submitted',
  REMAINING: 'remaining',
};

export const PERIOD = {
  PAST: 'past',
  CURRENT: 'current',
  FUTURE: 'future',
};

export const CHIP = {
  PAST: 'Past',
  CURRENT: 'Current',
  FUTURE: 'Future',
};

export const LOADING_MODAL_CONST = {
  HEADER_TITLE: 'Processing....',
  DESCRIPTION1:
    'Thank you for your submission. We are currently verifying and validating the details you provided. This will only take a moment.',
};

export const SIDEBAR_WARNING = {
  WARNING_MESSAGE:
    'Please allow time for data synchronization between individual opportunity line items and the summary data below. You can also manually refresh to ensure data synchronization.',
};
